import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './Styles'
import { FormattedMessage } from 'react-intl'
import AdditionalInfo from './AdditionalInfo'
import { SearchLoader } from '../Loader/SearchLoader'
import Alert from '@material-ui/lab/Alert'
import { UserConsumer } from '../../UserContext'
import PageTitle from '../Dashboard/PageTitle/PageTitle'
import BasicInfo from './BasicInfo'
import { NamedRoutes } from '../../routes'
import BreadCrumb from '../Dashboard/BreadCrumb'
import AdditionalSubscriptionInfo from './AdditionalSubscriptionInfo'

const UserEditProfileContent = ({ getCountries, getRoles, roles, getGovernments, governments, getCities, cities, adminSectionType, getSelectedUserData }) => {
  const classes = useStyles()
  React.useEffect(() => {
      getSelectedUserData()
      getRoles()
      if (!!adminSectionType && 'workspace' === adminSectionType) {
        getCountries()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Users'/>,
          link: NamedRoutes[adminSectionType].user.list
        }
      ]} current={<FormattedMessage id='UserEditProfileContent.title'/>}/>
      <PageTitle title={<FormattedMessage id='UserEditProfileContent.title'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <div className={classes.EditProfileContent}>
            <UserConsumer>
              {({
                  selectedUserDataLoading, selectedUserDataFailure, selectedUserData, updateUserAdditionalInfo,
                  updateSelectedUserProfileSuccess, updateSelectedUserProfileFailure
                }) => (
                <>
                  {!!selectedUserDataLoading && <SearchLoader loading={true}/>}
                  {!!selectedUserDataFailure &&
                  <Alert severity="error"><FormattedMessage id='BasicInfo.FormErrorAlert'/></Alert>
                  }
                  {!!selectedUserData && !!Object.keys(selectedUserData).length && !!roles && !!roles.length &&
                  <>
                    <BasicInfo userData={selectedUserData} forUsers={true}/>
                    {'subscription' === adminSectionType ?
                      <AdditionalSubscriptionInfo
                        userData={selectedUserData}
                        roles={roles}
                        submitForm={updateUserAdditionalInfo}
                        updateProfileSuccess={updateSelectedUserProfileSuccess}
                        updateProfileFailure={updateSelectedUserProfileFailure}
                        forUsers={true}
                      /> :
                      <AdditionalInfo
                        userData={selectedUserData}
                        getGovernments={getGovernments}
                        governments={governments}
                        getCities={getCities}
                        cities={cities}
                        roles={roles}
                        submitForm={updateUserAdditionalInfo}
                        updateProfileSuccess={updateSelectedUserProfileSuccess}
                        updateProfileFailure={updateSelectedUserProfileFailure}
                        forUsers={true}
                      />}
                  </>
                  }
                </>
              )}
            </UserConsumer>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default UserEditProfileContent
